module.exports = __webpack_public_path__ + "static/media/girlAtDesk.8f022670.png";